<div
  *ngIf="{
    isMobile: isMobile$ | async,
    mapIsShown: componentService.mapIsShown$ | async,
    suggestions: suggestionsService.suggestions$ | async,
    suggestIsLoading: suggestionsService.loading$ | async,
    ymapsIsLoading: ymapsService.isLoaded$ | async,
    isHeightLimit: isHeightLimit$ | async,
  } as observables"
  class="address-form"
>
  <form [formGroup]="form" (submit)="submitAddressValue()">
    <div class="address-field field" [ngClass]="{ onMap: observables.mapIsShown && observables.isMobile }">
      <sd-select>
        <ng-select
          #ngSelect
          [items]="observables.suggestions"
          bindLabel="value"
          bindValue="value"
          [loading]="observables.suggestIsLoading"
          loadingText="Идет поиск..."
          notFoundText="Ничего не найдено"
          typeToSearchText="Начинайте вводить адрес доставки"
          [dropdownPosition]="'bottom'"
          [editableSearchTerm]="true"
          name="address"
          formControlName="address"
          [typeahead]="selectTypeahead"
          (blur)="onBlurSelect($event)"
          (change)="onChangeSelect($event)"
          (search)="onSearchSelect($event)"
        ></ng-select>
      </sd-select>
      <cx-form-errors [control]="form.get('address')" [prefix]="'customCheckoutAddress.formErrors'"></cx-form-errors>
    </div>
    <div *ngIf="observables.isMobile" class="address-form-buttons">
      <button
        sdButton
        type="outlined"
        fullWidth="true"
        size="l"
        (click)="$event.preventDefault(); componentService.toggleMap()"
      >
        <cx-icon class="icon-point" [type]="iconType.POINT"></cx-icon>
        {{ observables.mapIsShown ? 'Скрыть карту' : 'Найти на карте' }}
      </button>
    </div>

    <div class="form-wrapper">
      <div *ngIf="!observables.mapIsShown || !observables.isMobile" class="form-fields">
        <div *ngIf="!observables.mapIsShown || !observables.isMobile" class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            formControlName="hasHeightLimit"
            name="hasHeightLimit"
            id="hasHeightLimit"
          />
          <label class="form-check-label" for="hasHeightLimit">Ограничение по высоте (арка, крытый паркинг)</label>
        </div>
        <div class="field" *ngIf="observables.isHeightLimit">
          <sd-select>
            <ng-select
              placeholder="Ограничение по высоте (арка, крытый паркинг)"
              bindLabel="name"
              bindValue="value"
              formControlName="heightLimit"
              name="heightLimit"
              [clearable]="false"
              [searchable]="false"
              [items]="heightLimit"
            ></ng-select>
          </sd-select>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            formControlName="privateHouse"
            name="privateHouse"
            id="privateHouse"
          />
          <label class="form-check-label" for="privateHouse">Частный дом</label>
        </div>
        <div class="address-fields">
          <sd-form-field-new label="Квартира">
            <input type="text" formControlName="appartment" name="appartment" maxlength="5" />
          </sd-form-field-new>
          <sd-form-field-new label="Подъезд">
            <input type="text" formControlName="entrance" name="entrance" maxlength="3" />
          </sd-form-field-new>
          <sd-form-field-new [control]="form.get('floor')" label="Этаж">
            <input
              type="number"
              name="floor"
              [formControl]="form.get('floor')"
              [sdMaxNumber]="255"
              [sdMinNumber]="0"
              sdOnlyNumber="integer"
            />
          </sd-form-field-new>
          <sd-form-field-new label="Домофон">
            <input type="text" formControlName="domofon" name="domofon" maxlength="15" />
          </sd-form-field-new>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" formControlName="cargoLift" name="cargoLift" id="cargoLift" />
          <label class="form-check-label" for="cargoLift">Грузовой Лифт</label>
        </div>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            formControlName="passengerLift"
            name="passengerLift"
            id="passengerLift"
          />
          <label class="form-check-label" for="passengerLift">Пассажирский Лифт</label>
        </div>
        <button
          sdButton
          type="accent"
          size="l"
          fullWidth="true"
          *ngIf="!observables.mapIsShown || !observables.isMobile"
          autofocus
        >
          Сохранить
        </button>
      </div>
      <sd-delivery-address-map *ngIf="observables.mapIsShown || !observables.isMobile"></sd-delivery-address-map>
    </div>
    <div *ngIf="observables.mapIsShown && observables.isMobile" class="send-btn-wrapper">
      <button
        (click)="$event.preventDefault(); componentService.toggleMap()"
        type="button"
        class="btn btn-secondary btn-map btn-md"
      >
        <cx-icon class="icon" [type]="iconType.POINT"></cx-icon>
        {{ observables.mapIsShown ? 'Скрыть карту' : 'Найти на карте' }}
      </button>
      <button
        type="button"
        (click)="$event.preventDefault(); componentService.closeMap()"
        class="btn btn-primary send-btn"
      >
        Применить
      </button>
    </div>
  </form>
</div>
